import Model, {
  attr,
  belongsTo,
  type HasMany,
  hasMany,
} from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type { LookerDashboard, LookerLook } from 'lumen/models';

export default class LookerFolder extends Model {
  [Type] = 'looker-folder' as const;

  @belongsTo('looker-folder', { async: false, inverse: 'folders' })
  declare folder: LookerFolder;

  @hasMany('looker-dashboard', { async: false, inverse: 'folder' })
  declare dashboards: HasMany<LookerDashboard>;

  @hasMany('looker-folder', { async: false, inverse: 'folder' })
  declare folders: HasMany<LookerFolder>;

  @hasMany('looker-look', { async: false, inverse: 'folder' })
  declare looks: HasMany<LookerLook>;

  @attr('boolean') declare canEdit: boolean;
  @attr('boolean') declare isEmbedSharedRoot: boolean;
  @attr('boolean') declare isPersonal: boolean;
  @attr('boolean') declare isSharedRoot: boolean;
  @attr('string') declare name: string;
}
